import { Component, OnInit } from '@angular/core';
import { Validator } from 'projects/core/src/lib/helpers/validator';
import { environment } from 'projects/environments/environment';
import { AdminComponent } from '../../../pages/admin/admin.component';
import { AuthStateService } from '../../../services/auth-state.service';
import { MENUITEMS_DEFAULT } from './config/default';
import { MENUITEMS_PLANNER } from './config/planner';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

  public menuitems: Array<any> = [];
  public version: string;
  public sysType: string | null = null;
  public sysMode: string | null = null;

  constructor(
    private app: AdminComponent,
    private auth: AuthStateService
  ) {
    this.version = environment.version;
  }

  ngOnInit(): void {
    // get sysinfo
    this.sysType = this.auth.getSysType();
    this.sysMode = this.auth.getSysMode();
    // build menu
    let items = [];
    switch (this.sysMode) {
      case 'planner': {
        items = MENUITEMS_PLANNER;
        break;
      }
      default: {
        items = MENUITEMS_DEFAULT;
        break;
      }
    }
    this.menuitems = items.filter((item: any) => {
      return item.condition === undefined || this.conditionMatches(item.condition);
    });
  }

  public onMenuClick(): void {
    this.app.onMenuClick();
  }

  public hasRights(item: any): boolean {
    let result = false;
    if (Validator.isArray(item.items)) {
      item.items.forEach((actual: any) => {
        if (actual.right === undefined || this.auth.hasRight(actual.right)) {
          result = true;
        }
      });
    }
    return result;
  }

  public conditionMatches(condition: string): boolean {
    switch (condition) {
      case 'with_availabilities': {
        return this.auth.hasAvailabilities() === true;
        break;
      }
    }
    return false;
  }

}
